export default ({ intent = '', message = '' } = {}): string =>
  `${intent ? `I'm interested in:\n- ${intent}` : ''}\n\n${message}`;
